import React, { useState, useEffect, useRef } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { Link } from "react-router-dom";
import config from "../common/Config";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { setTableWidths, getTableWidths } from "../../data/postAPi";

const ReturnList = () => {
  const returnListRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
  const userId = localStorage.getItem("userId");
  const tableName = "returnListTable";

  const [statusFilter, setStatusFilter] = useState("Pending");
  const [editModal, setEditModal] = useState({
    open: false,
    id: null,
    amount: "",
  });

  // Updated column widths state with proper default values
  const [colWidths, setColWidths] = useState([120, 150, 250, 120, 150, 100, 150, 100, 120]);

  // Debounced function to save table widths
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;

  // Column resizing functionality
  const startResizing = (index, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];

    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  // Load saved column widths on component mount
  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([120, 150, 250, 120, 150, 100, 150, 100, 120]);
        }
      } catch (e) {
        setColWidths([120, 150, 250, 120, 150, 100, 150, 100, 120]);
      }
    }
    fetchWidths();
  }, []);

  const getReturnList = () => {
    const $table = $(returnListRef.current);

    if ($.fn.DataTable.isDataTable($table)) {
      $table.DataTable().clear().destroy();
      $table.empty();
    }

    const headers = ["Date", "Return No", "Customer (Ac/No)", "Grand Total", "Credit Note", "Total Items", "Return By", "Status"];
    if (statusFilter === "Pending") {
      headers.push("Actions");
    }

    // Create table header with resizing handles
    const thead = `
      <thead>
        <tr>
          ${headers.map((header, idx) => `
            <th style="width: ${colWidths[idx]}px; min-width: 50px; position: relative;">
              ${header}
              ${idx < headers.length - 1 ? `
                <div
                  class="th-resizer"
                  style="
                    position: absolute;
                    right: -2px;
                    top: 0;
                    width: 5px;
                    height: 100%;
                    cursor: col-resize;
                    z-index: 999;
                    user-select: none;
                  "
                  data-column-index="${idx}"
                ></div>
              ` : ''}
            </th>
          `).join('')}
        </tr>
      </thead>
    `;
    $table.append(thead);

    const columns = [
      { data: "date", width: colWidths[0] + 'px' },
      {
        data: "reference_no",
        width: colWidths[1] + 'px',
        render: (data, type, row) =>
          `<a href="${config.BASE_URL}/returns/view/${row.id}">${data}</a>`,
      },
      { data: "company", width: colWidths[2] + 'px' },
      { data: "grand_total", width: colWidths[3] + 'px' },
      {
        data: "credit_note",
        width: colWidths[4] + 'px',
        render: function (data, type, row) {
          if (isNaN(data)) return data;

          let formattedAmount = parseFloat(data).toFixed(2);

          if (statusFilter === "Pending") {
            return `<a href="javascript:void(0);" class="edit-amount-btn" data-id="${row.id}" data-amount="${data}" title="Edit Amount">${formattedAmount}</a>`;
          }

          return formattedAmount;
        },
      },
      { data: "total_items", width: colWidths[5] + 'px' },
      { data: "return_by", width: colWidths[6] + 'px' },
      { data: "status", width: colWidths[7] + 'px' },
    ];

    if (statusFilter === "Pending") {
      columns.push({
        data: null,
        width: colWidths[8] + 'px',
        render: (data, type, row) => `
          <div>
            <a href="javascript:void(0);" class="deductionbtn" data-id="${row.id}" data-action="accept" title="Accept Return"><i class="bi bi-check-square-fill"></i></a>
            <a href="javascript:void(0);" class="applybtn" data-id="${row.id}" data-action="reject" title="Reject Return"><i class="bi bi-sign-turn-right-fill"></i></a>
          </div>`,
      });
    }

    const table = $table.DataTable({
      processing: true,
      serverSide: true,
      ajax: {
        url: `${config.API_URL}/return/returnList_v2`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: (d) => ({ ...d, status: statusFilter }),
        dataSrc: (json) => (Array.isArray(json.data) ? json.data : []),
      },
      columns,
      columnDefs: [{ orderable: false, targets: "_all" }],
      pageLength: 50,
      autoWidth: false,
      drawCallback: () => {
        // Add event handlers for action buttons
        $(document)
          .off("click", ".deductionbtn")
          .on("click", ".deductionbtn", function (e) {
            const id = $(this).data("id");
            handelAcceptReject(id, "accept");
          });
        $(document)
          .off("click", ".applybtn")
          .on("click", ".applybtn", function (e) {
            const id = $(this).data("id");
            handelAcceptReject(id, "reject");
          });
        $(document)
          .off("click", ".edit-amount-btn")
          .on("click", ".edit-amount-btn", function (e) {
            const id = $(this).data("id");
            const currentAmount = $(this).data("amount");
            showEditAmountPopup(id, currentAmount);
          });

        // Add resizer event handlers after table is drawn
        setTimeout(() => {
          const resizers = document.querySelectorAll('#returnListTable .th-resizer');
          resizers.forEach((resizer, index) => {
            const handleMouseDown = (e) => {
              e.preventDefault();
              e.stopPropagation();
              startResizing(index, e);
            };

            // Remove existing handlers to prevent duplicates
            resizer.removeEventListener('mousedown', resizer._resizerHandler);
            resizer.addEventListener('mousedown', handleMouseDown);
            resizer._resizerHandler = handleMouseDown;
          });
        }, 100);
      },
    });
  };

  const handelAcceptReject = async (id, action) => {
    const confirmMessage =
      action === "accept"
        ? "Are you sure you want to create the Credit Note?"
        : "Are you sure you want to reject this order?";

    const result = await Swal.fire({
      title: "Are you sure?",
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (result.isConfirmed) {
      const url =
        action === "accept"
          ? `${config.API_URL}/add_accept_return`
          : `${config.API_URL}/add_reject_return`;

      const formData = new FormData();
      formData.append("id", id);
      if (action === "accept") {
        formData.append("allocation", "yes");
      }

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        });

        const data = await response.json();
        if (data.success) {
          Swal.fire({
            title: "Success!",
            text: data.message || "Action completed successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            getReturnList();
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: data.message || "An error occurred.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("API request failed:", error);
      }
    }
  };

  const showEditAmountPopup = (id, currentAmount) => {
    setEditModal({
      open: true,
      id,
      amount: currentAmount,
    });
    setTimeout(() => {
      const modalEl = document.getElementById("editAmountModal");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 0);
  };

  const handleEditAmountClose = () => {
    setEditModal({ open: false, id: null, amount: "" });
    const modalEl = document.getElementById("editAmountModal");
    if (modalEl) {
      const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
      modal.hide();
    }
  };

  const handleEditAmountSubmit = async (e) => {
    if (e) e.preventDefault();
    const userId = localStorage.getItem("userId") || "";
    const amount = editModal.amount;
    if (!amount || isNaN(amount) || parseFloat(amount) < 0) {
      alert("Please enter a valid amount");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("id", editModal.id);
      formData.append("user_id", userId);
      formData.append("amount", amount);

      setEditModal({ open: false, id: null, amount: "" });
      const modalEl = document.getElementById("editAmountModal");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.hide();
      }

      setTimeout(async () => {
        const response = await fetch(
          `${config.API_URL}/return/update_credit_amount`,
          {
            method: "POST",
            headers: {
              authorization: `Bearer ${accessToken}`,
            },
            body: formData,
          }
        );
        const data = await response.json();
        if (data.success) {
          Swal.fire({
            title: "Success!",
            text: data.message || "Amount updated successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            getReturnList();
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: data.message || "An error occurred.",
            icon: "error",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      }, 0);
    } catch (error) {
      Swal.fire({
        title: "Failed!",
        text: "API request failed.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  // Add CSS styles for resizer
  const resizerStyles = `
    .th-resizer {
      background-color: transparent;
      transition: background-color 0.2s ease;
    }
    
    .th-resizer:hover {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    
    .resizable-header {
      position: relative;
      user-select: none;
    }

    #returnListTable th {
      position: relative;
      user-select: none;
    }

    #returnListTable .th-resizer {
      position: absolute;
      right: -2px;
      top: 0;
      width: 5px;
      height: 100%;
      cursor: col-resize;
      z-index: 999;
      user-select: none;
    }
  `;

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = resizerStyles;
    document.head.appendChild(styleSheet);

    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    $(document)
      .off("click", "#returnStatusTabs .nav-link")
      .on("click", "#returnStatusTabs .nav-link", function (e) {
        e.preventDefault();
        $("#returnStatusTabs .nav-link").removeClass("active");
        $(this).addClass("active");
        const selectedStatus = $(this).data("status");
        setStatusFilter(selectedStatus);
      });

    return () => {
      $(document).off("click", "#returnStatusTabs .nav-link");
    };
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      getReturnList();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [statusFilter, colWidths]);
  // Added colWidths dependency to re-render when widths change

  return (
    <div>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <Link to="/Dashboard">
                <i className="fa fa-home"></i>
              </Link>
              <Link to="#">Return</Link>
              <Link to="#">Return List</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div>
                <div style={{ float: "right" }}>
                  <a
                    href={`${config.BASE_URL}/return/add_return`}
                    className="create-catalogue-btn"
                  >
                    Add Return
                  </a>
                </div>

                <ul className="nav nav-tabs mb-3" id="returnStatusTabs">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      href="#"
                      data-status="Pending"
                    >
                      Pending
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-status="Accepted">
                      Accepted
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" data-status="Rejected">
                      Rejected
                    </a>
                  </li>
                </ul>

                <div className="show-order-area dashboard">
                  <div
                    className="verical-scrl-wrapper returnlist-table"
                    id="style-3"
                  >
                    <table
                      className="table table-bordered dataTable resizable resizable-columns"
                      id="returnListTable"
                      ref={returnListRef}
                    >
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div
        className="modal fade"
        id="editAmountModal"
        tabIndex="-1"
        aria-labelledby="editAmountModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form onSubmit={handleEditAmountSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="editAmountModalLabel">
                  Edit Credit Note
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleEditAmountClose}
                ></button>
              </div>
              <div className="modal-body">
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={editModal.amount}
                  onChange={(e) =>
                    setEditModal({ ...editModal, amount: e.target.value })
                  }
                  className="form-control"
                />
                <br />
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary btn-sm">
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  data-bs-dismiss="modal"
                  onClick={handleEditAmountClose}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnList;